import { gql } from 'application/providers/DataProvider';

export const BUSINESS_PROFILE_SET_SELECTED_PLAYLIST_QUERY = gql`
  query businessProfileSetSelectedPlaylist {
    playlist @client
  }
`;
